import {isEqual} from "@pg-mono/nodash";

import {ValidOfferApiParams} from "../../../../generated/valid_offer_api_params";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";
import {getValidOfferListQuery, ValidOfferListQuery} from "./validate_offer_list_query";

type OfferListingQuery = Record<string, string | string[] | null | boolean | undefined>;

const toValidOfferListQuery = (query: OfferListingQuery): ValidOfferListQuery => getValidOfferListQuery(query as Parameters<typeof getValidOfferListQuery>[0]);

export const isOfferListingRouteQuerySyncedWithLatestQuery = (routeQuery: OfferListingQuery, latestQuery: OfferListingQuery): boolean => {
    if (isPromotionsListingQuery(routeQuery) !== isPromotionsListingQuery(latestQuery)) {
        return false;
    }

    const validRouteQuery = toValidOfferListQuery(routeQuery);
    const validLatestQuery = toValidOfferListQuery(latestQuery);

    return (Object.keys(validRouteQuery) as ValidOfferApiParams[]).every((key) => isEqual(validRouteQuery[key], validLatestQuery[key]));
};
import {isEqual} from "@pg-mono/nodash";

import {ValidOfferApiParams} from "../../../../generated/valid_offer_api_params";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";
import {getValidOfferListQuery, ValidOfferListQuery} from "./validate_offer_list_query";

type OfferListingQuery = Record<string, string | string[] | null | boolean | undefined>;

const toValidOfferListQuery = (query: OfferListingQuery): ValidOfferListQuery => getValidOfferListQuery(query as Parameters<typeof getValidOfferListQuery>[0]);

export const isOfferListingRouteQuerySyncedWithLatestQuery = (routeQuery: OfferListingQuery, latestQuery: OfferListingQuery): boolean => {
    if (isPromotionsListingQuery(routeQuery) !== isPromotionsListingQuery(latestQuery)) {
        return false;
    }

    const validRouteQuery = toValidOfferListQuery(routeQuery);
    const validLatestQuery = toValidOfferListQuery(latestQuery);

    return (Object.keys(validRouteQuery) as ValidOfferApiParams[]).every((key) => isEqual(validRouteQuery[key], validLatestQuery[key]));
};
